import { useState, type FormEvent } from 'react';
import { Link } from 'react-router-dom';
import { api } from '@/lib/apiClient';

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const onSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      await api.post('/auth/reset-password', { email: email.trim() });
      setSent(true);
    } catch (err: any) {
      setError(err?.response?.data?.message || 'Could not send reset email. Please try again.');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div
      className="flex min-h-screen items-center justify-center p-6"
      style={{ background: 'linear-gradient(135deg, #0D1B2A 0%, #1B263B 50%, #415A77 100%)' }}
    >
      <div className="w-full max-w-md rounded-2xl bg-white p-8 shadow-2xl">
        <h1 className="text-xl font-semibold text-flock-navy-900">Reset your password</h1>
        {sent ? (
          <div className="mt-4 rounded-lg border border-green-200 bg-green-50 px-4 py-3 text-sm text-green-800">
            If an account exists with that email, reset instructions have been sent.
          </div>
        ) : (
          <form onSubmit={onSubmit} className="mt-4 space-y-4">
            {error && (
              <div className="rounded-lg border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-700">
                {error}
              </div>
            )}
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full rounded-lg border border-flock-gray-300 px-4 py-2.5 text-flock-navy-900 outline-none focus:border-flock-navy-600 focus:ring-2 focus:ring-flock-navy-600/20"
              placeholder="you@church.org"
            />
            <button
              type="submit"
              disabled={busy}
              className="min-h-touch w-full rounded-lg bg-flock-navy-600 px-4 py-2.5 font-medium text-white transition hover:bg-flock-navy-700 disabled:opacity-60"
            >
              {busy ? 'Sending…' : 'Send Reset Email'}
            </button>
          </form>
        )}
        <div className="mt-6 text-center text-sm">
          <Link to="/login" className="text-flock-navy-600 hover:underline">
            Back to sign in
          </Link>
        </div>
      </div>
    </div>
  );
}
